"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Dialog_1 = require("mobile/components/Dialog");
var lang_1 = require("utils/lang");
var style_1 = require("./style");
var getLang = lang_1.getEzbuyLang();
var GamesRedeem = (function (_super) {
    __extends(GamesRedeem, _super);
    function GamesRedeem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamesRedeem.prototype.render = function () {
        var _a = this.props, show = _a.show, onClose = _a.onClose, onEnter = _a.onEnter;
        return (React.createElement(Dialog_1.default, { show: show, isAutoFixedBody: true, style: { background: "rgba(0, 0, 0, 0.8)" } },
            React.createElement(style_1.GamesBackground, null,
                React.createElement(style_1.GamesTitle, null, getLang("Successfully!")),
                React.createElement(style_1.GamesSubtitle, null, getLang("You have gotten a free dice"))),
            React.createElement(style_1.GamesButton, { onClick: onEnter }, getLang("Back to game")),
            React.createElement(style_1.GamesButton, { onClick: onClose }, getLang("Stay here"))));
    };
    return GamesRedeem;
}(React.PureComponent));
exports.default = GamesRedeem;
